import React from "react";

export const AddIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6665 3.33333C8.6665 2.96514 8.36803 2.66666 7.99984 2.66666C7.63165 2.66666 7.33317 2.96514 7.33317 3.33333V7.33333H3.33317C2.96498 7.33333 2.6665 7.63181 2.6665 8C2.6665 8.36819 2.96498 8.66666 3.33317 8.66666H7.33317V12.6667C7.33317 13.0349 7.63165 13.3333 7.99984 13.3333C8.36803 13.3333 8.6665 13.0349 8.6665 12.6667V8.66666H12.6665C13.0347 8.66666 13.3332 8.36819 13.3332 8C13.3332 7.63181 13.0347 7.33333 12.6665 7.33333H8.6665V3.33333Z"
        fill="white"
      />
    </svg>
  );
};
